/**
 * WithdrawAccountPresenter
 * --
 */
import React from 'react';
import { Content, Row, Col, Title } from 'components';
import { Button, Checkbox } from 'antd';
import { SideMenu } from '../Mypage/components';

const WithdrawPresenter = ({ screenSize, isChecked, onToggle, onSubmit }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
      lineHeight: '120%',
      fontWeight: 700,
      color: 'var(--black-color)',
      paddingBottom: 24,
      borderBottom: '2px solid var(--black-color)',
    },

    icon: {
      fontSize: 24,
    },
  };

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content
      maxWidth={1820}
      padding={screenSize >= 768 ? '100px 0px' : '60px 0'}
    >
      <Row gutter={16}>
        <Col x={1} md={2}></Col>
        <Col x={0} md={4}>
          <SideMenu />
        </Col>
        <Col x={22} md={16}>
          <Content
            maxWidth={'100%'}
            padding={screenSize >= 768 ? '0 0 0 95px' : '0'}
          >
            <Title /* align={'center'} */ style={{ ...styles.title }}>
              회원탈퇴
            </Title>
            <Content maxWidth={'100%'} padding={0}>
              {/* <Title size={3} align={'center'} color="#D33444">
                경고!
              </Title> */}
              <Content
                padding={0}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 12,
                  margin: '32px 0',
                }}
              >
                <span style={{ fontSize: screenSize >= 768 ? 24 : 18 }}>
                  회원탈퇴 안내
                </span>
                <span
                  style={{
                    fontSize: screenSize >= 768 ? 20 : 16,
                    wordBreak: 'keep-all',
                    color: 'var(--red-secondary-color)',
                  }}
                >
                  회원 탈퇴 전 아래 사항을 반드시 숙지해 주시기 바랍니다.
                </span>
              </Content>
              <Content
                maxWidth={'100%'}
                padding={0}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: screenSize >= 768 ? '24px 40px' : '24px 15px',
                  backgroundColor: '#f4f4f4',
                  color: 'var(--black-color)',
                  lineHeight: 1.75,
                  marginBottom: screenSize >= 768 ? 100 : 60,
                }}
              >
                <span
                  style={{
                    marginBottom: 16,
                    fontWeight: 700,
                  }}
                >
                  회원탈퇴 유의사항
                </span>
                <span>
                  ∙ 회원 탈퇴 시 보유하고 계신 쿠폰과 마일리지는 즉시 자동 소멸
                  됩니다.
                </span>
                <span>
                  ∙ 진행중인 주문, 교환, 반품이 있다면, 회원 탈퇴가 불가합니다.
                </span>
                <span>
                  ∙ 모든 주문, 교환, 반품이 완료된 후 탈퇴하실 수 있습니다.
                </span>
                <span>
                  ∙ 진행중인 상담이 있을 경우, 상담완료 후 탈퇴하실 수 있습니다.
                </span>
                <span>
                  ∙ 거래 정보가 있는 경우, 판매 거래 정보 관리를 위하여 구매와
                  관련된 상품정보, 아이디, 거래내역 등에 대한 기본정보는 탈퇴 후
                  5년간 보관됩니다.
                </span>
                <span>
                  ∙ 회원 탈퇴 후 재가입 시에는 신규 가입 혜택이 제공되지 않으며,
                  탈퇴 전의 회원정보와 거래정보 및 마일리지, 쿠폰 정보 등은
                  복구되지 않습니다.
                </span>
                <span>
                  ∙ 이벤트 및 프로모션 부정 이용 방지 등을 위하여 탈퇴일로부터
                  7일 이내에는 재가입이 불가합니다.
                </span>
              </Content>
              {/* <Title size={4} align={'center'} style={{ marginTop: 10 }}>
                회원 탈퇴 시 지금까지 적립하신 모든 캐시 및 포인트,
                <br />
                개인정보가 삭제되며 복구할 수 없습니다.
                <br />
                정말 삭제하시겠습니까?
              </Title> */}
              <Content
                padding={0}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 12,
                  marginTop: 32,
                }}
              >
                <button
                  style={{ border: 'none', background: 'none' }}
                  onClick={() => onToggle(!isChecked)}
                >
                  {isChecked ? (
                    <Checkbox style={{ ...styles.icon, color: '#111111' }} />
                  ) : (
                    <Checkbox style={{ ...styles.icon, color: '#BDBDBD' }} />
                  )}
                </button>
                <p style={{ fontSize: 16 }}>위 내용을 확인하였고 동의합니다.</p>
              </Content>
              <Button
                disabled={!isChecked}
                type="primary"
                style={{
                  width: '240px',
                  height: 34,
                  fontSize: 16,
                  margin: ' 32px auto 0',
                  padding: '24px 52px',
                  borderRadius: '2px',
                  display: 'flex',
                  justifyContent: 'center',
                }}
                onClick={() => onSubmit()}
              >
                회원 탈퇴
              </Button>
            </Content>
          </Content>
        </Col>
        <Col x={1} md={2}></Col>
      </Row>
    </Content>
  );
};

export default WithdrawPresenter;
